import { render } from "./Login2.vue?vue&type=template&id=cded7aae&scoped=true"
import script from "./Login2.vue?vue&type=script&lang=js"
export * from "./Login2.vue?vue&type=script&lang=js"

import "./Login2.vue?vue&type=style&index=0&id=cded7aae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cded7aae"]])

export default __exports__